import { useEffect, useState } from "react";
import { SelectInput, useGetList, useInput } from "react-admin";
import { studentRequests } from "api/studentApi";
import { useFormContext } from "react-hook-form";
import { useWeekContext } from "../../utils/useWeekContext";

const WeekSelectInput = props => {
  const { defaultValue, semesterAndWeek, isChild, source, contextMode = "create", ...rest } = props;

  const { setValue } = useFormContext();
  const { field } = useInput({ source });

  const { curriculumId, academicYearSessionId, schedules } = useWeekContext(contextMode);
  const course = props.scopedFormData?.course || schedules?.[0]?.course;

  const [choices, setChoices] = useState([]);

  const { data: sessions } = useGetList(
    studentRequests.getAcademicSessionsSelect(),
    {
      filter: { ids: [academicYearSessionId] },
      pagination: { page: 1, perPage: 1 },
      sort: { field: "id", order: "ASC" },
    },
    { enabled: !!academicYearSessionId },
  );
  const session = sessions ? sessions[0] : null;
  const chosenSessionType = session?.sessionType;

  useEffect(() => {
    if (!course || !chosenSessionType || !semesterAndWeek) {
      setChoices([]);
      return;
    }
    const semester = chosenSessionType === 3 ? course * 2 - 1 : course * 2;
    const weeksCount = semesterAndWeek[semester] ?? 0;

    const newChoices =
      weeksCount > 0
        ? Array.from({ length: weeksCount }, (_, i) => ({
            id: i + 1,
            name: `Седмица ${i + 1}`,
          }))
        : [];
    setChoices(newChoices);
  }, [chosenSessionType, course, semesterAndWeek]);

  useEffect(() => {
    if (isChild && defaultValue !== undefined && choices.some(c => c.id === defaultValue)) {
      setValue(field.name, defaultValue, { shouldValidate: true });
    }
  }, [defaultValue, isChild, source, setValue, choices]);

  return (
    <SelectInput
      {...rest}
      {...field}
      source={field.name}
      choices={choices || []}
      disabled={!curriculumId}
      optionValue="id"
      optionText="name"
    />
  );
};

export default WeekSelectInput;
